import BusinessList from './views/business-list.c';
export default BusinessList;
